import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import type { SafetyCaseRecord } from '../../services/reportsApi';
import type { SafetyScanHandoffParams } from '../../domain/safetyCases/safetyScanWorkspaceHandoff';
import { buildLinkedSafetyCaseContextLines } from '../../domain/safetyCases/safetyScanWorkspaceHandoff';

type Props = {
  linkedCase: SafetyCaseRecord | null;
  handoff: SafetyScanHandoffParams;
};

export default function SafetyScanLinkedCaseContextBlock({ linkedCase, handoff }: Props) {
  if (!linkedCase) return null;
  const lines = buildLinkedSafetyCaseContextLines(linkedCase, handoff);

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2.5 }} data-testid="linked-safety-case-context">
      <Stack spacing={1.25}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Linked Safety Case
        </Typography>
        <Box sx={{ display: 'grid', gap: 0.75, gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' } }}>
          {lines.map((line) => (
            <Typography key={line.label} variant="body2">
              <Box component="span" sx={{ fontWeight: 700 }}>{`${line.label}: `}</Box>
              {line.value}
            </Typography>
          ))}
        </Box>
      </Stack>
    </Paper>
  );
}
